'use strict';
var ibmUserHover = (function () {
    function ibmUserHover() {
        this.restrict = 'A';
    }
    ibmUserHover.prototype.link = function (scope, element) {
        element.bind('mouseover', function () {
            element.addClass("ibm-active");
        });
        element.bind('mouseout', function (e) {
            element.removeClass("ibm-active");
        });
    };
    ibmUserHover.instance = function () {
        return new ibmUserHover;
    };
    return ibmUserHover;
}());
angular
    .module('application')
    .directive('ibmUserHover', ibmUserHover.instance);

//# sourceMappingURL=ibm-user-hover.js.map
